import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DragulaService } from "ng2-dragula";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var alertify: any;

@Component({
  selector: "app-question-list",
  templateUrl: "./question-list.component.html",
  styleUrls: ["./question-list.component.css"],
})
export class QuestionListComponent implements OnInit {
  constructor(
    private router: Router,
    private http: HttpService,
    private dragulaService: DragulaService
  ) {
    dragulaService.drop.subscribe((value) => {
      //console.log('drop: ${value[0]}');
      this.onDrop(value.slice(1));
    });
  }

  ngOnInit() {
    this.getPath();
  }

  private data: any = [];
  private imagePath: string = "";

  private onDrop(args) {
    let [e, el] = args;
    // do something
    this.getList();
  }

  private postData: any = [];

  //推送
  public isLoading: boolean = false;
  private push(id: any): void {
    this.isLoading = true;
    this.http
      .postData(
        API.sendNewsNotifyPushAll + "?" + "id" + "=" + id,
        this.postData
      )
      .then((res) => {
        let data = res;
        this.isLoading = false;
        if (data.status.code == 0 || data.status.code == "0") {
          alertify.success(data.status.message);
        } else {
          alertify.error(data.status.message);
        }
      });
  }
  //成员推送
  private memberPush(id: any): void {
    this.isLoading = true;
    this.http
      .postData(API.sendNewsNotifyPush + "?" + "id" + "=" + id, this.postData)
      .then((res) => {
        let data = res;
        this.isLoading = false;
        if (data.status.code == 0 || data.status.code == "0") {
          alertify.success(data.status.message);
        } else {
          alertify.error(data.status.message);
        }
      });
  }

  //获取排序列表
  private getList() {
    this.postData = [];
    for (let i = 1; i < this.data.length + 1; i++) {
      this.postData.push({ id: this.data[i - 1].id, rank: i });
    }
  }

  private sort(): void {
    this.http.postData(API.question + "/sort", this.postData).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        alertify.success(data.status.message);
      } else {
        alertify.error(data.status.message);
      }
    });
  }

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  public searchValue = {
    active: "",
  };

  private getData(isSearch = false) {
    let data;
    if (isSearch) {
      data = { ...this.searchValue };
    }
    this.http.getData(API.question, data).then((res) => {
      this.data = res.data;
      for (let i = 0; i < this.data.length; i++) {
        this.data[i].imageEn = this.imagePath + this.data[i].imageEn;
        this.data[i].imageTc = this.imagePath + this.data[i].imageTc;
      }
    });
  }

  private editQues(id: number): void {
    this.router.navigate(["index/question", id]);
  }

  private deleteQues(id: number): void {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.deleteData(API.question + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }

  private ngOnDestroy() {
    this.dragulaService.destroy("evented-bag");
  }

  public searchData() {
    this.getData(true);
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/question-list/question-list.component.ts